module.exports = __webpack_public_path__ + "media/img/pages/profile/ckw ger 9-6738385d5f93e94a88dbdf2d17269873.webp";